/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getReport } from '../fn/reports/get-report';
import { GetReport$Params } from '../fn/reports/get-report';
import { Report } from '../models/report';

@Injectable({ providedIn: 'root' })
export class ReportsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getReport()` */
  static readonly GetReportPath = '/reports/{agent_id}';

  /**
   * Get Report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReport$Response(params: GetReport$Params, context?: HttpContext): Observable<StrictHttpResponse<Report>> {
    return getReport(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReport(params: GetReport$Params, context?: HttpContext): Observable<Report> {
    return this.getReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<Report>): Report => r.body)
    );
  }

}
